import { OperationService } from "@/services";
export default {
  name: "otp-card",
  components: {},
  props: {
    phoneNumber: {
      type: String
    },
    countDown: {
      type: Object
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialog: true,
      otpCode: "",
      clockInterval: "",
      toggleMethod: false
    };
  },
  computed: {},
  mounted() {},
  methods: {
    handleDialog() {
      this.$emit("confirmOtpCode", this.otpCode, true);
      // this.dialog = true;
    },
    resendOtpCode() {
      OperationService.resendAddressOtp({
        address_id: this.countDown.addAddressId
      }).then(response => {
        this.$emit("onResendOtp", response.data.data.ttl / 1000);
      });
    }
  }
};
